import { useStore } from '@tanstack/react-form';
import { ParticipantFeedbackContext } from '../employee-review/components/ParticipantFeedbackContext';
import type { DetailFormJsMethodProps } from './registry';

export const EmployeeReviewFeedbackContextJsMethodBinding = ({
  form,
  parentId,
}: DetailFormJsMethodProps) => {
  const formValues = useStore(form.store, (state) => {
    return (state as { values?: Record<string, unknown> }).values ?? {};
  });
  const queryReviewId = Number(new URLSearchParams(window.location.search).get('reviewId'));
  const formReviewId = Number(formValues.Id ?? formValues.id);
  const reviewId =
    Number.isInteger(queryReviewId) && queryReviewId > 0
      ? queryReviewId
      : Number.isInteger(formReviewId) && formReviewId > 0
        ? formReviewId
        : Number(parentId);

  if (!Number.isInteger(reviewId) || reviewId <= 0) return null;

  return <ParticipantFeedbackContext reviewId={reviewId} />;
};
